import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

/** Переключатель темы: тихая круглая кнопка с иконкой. */
export function ThemeToggle({ className = '', testId = 'theme-toggle' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid={testId}
      aria-label={isDark ? 'Включить светлую тему' : 'Включить тёмную тему'}
      aria-pressed={isDark}
      className={[
        'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
        'border border-border text-muted-foreground',
        'transition-colors duration-2 ease-out',
        'hover:text-foreground hover:border-foreground/25',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isDark ? (
        <Moon className="h-[18px] w-[18px]" strokeWidth={2} aria-hidden />
      ) : (
        <Sun className="h-[18px] w-[18px]" strokeWidth={2} aria-hidden />
      )}
    </button>
  );
}
